import type { UpdateTciSessionPayload } from "@/lib/api/tci-sessions";
import { parseNumericInput } from "@/lib/tci";
import type { TciSession } from "@/providers/tci-session-context";

function finiteOrUndefined(value: number): number | undefined {
  return Number.isFinite(value) ? value : undefined;
}

/** Map local calculator draft fields into a PATCH payload (numbers only when set). */
export function sessionInputsToTrackingPayload(
  session: TciSession,
): UpdateTciSessionPayload {
  const payload: UpdateTciSessionPayload = {};

  if (session.workflowId) payload.workflowId = session.workflowId;
  if (session.regionId) payload.regionId = session.regionId;
  if (session.businessSector) {
    payload.businessSector = session.businessSector;
  }
  const organisationName = session.organisationName.trim();
  if (organisationName) {
    payload.organisationName = organisationName;
  }

  const laborHeadcount = parseNumericInput(session.labor.headcount);
  const laborSalary = parseNumericInput(session.labor.salary);
  const yieldVolume = parseNumericInput(session.yieldPenalty.volume);
  const yieldPenaltyPerEvent = parseNumericInput(
    session.yieldPenalty.penaltyPerEvent,
  );
  const untappedVolume = parseNumericInput(session.untapped.volume);
  const untappedValuePerAction = parseNumericInput(
    session.untapped.valuePerAction,
  );
  const annualEbitda = parseNumericInput(session.annualEbitda);

  if (finiteOrUndefined(laborHeadcount) !== undefined) {
    payload.laborHeadcount = laborHeadcount;
  }
  payload.laborTimePercent = session.labor.timePercent;
  if (finiteOrUndefined(laborSalary) !== undefined) {
    payload.laborSalary = laborSalary;
  }
  if (finiteOrUndefined(yieldVolume) !== undefined) {
    payload.yieldVolume = yieldVolume;
  }
  if (finiteOrUndefined(yieldPenaltyPerEvent) !== undefined) {
    payload.yieldPenaltyPerEvent = yieldPenaltyPerEvent;
  }
  if (finiteOrUndefined(untappedVolume) !== undefined) {
    payload.untappedVolume = untappedVolume;
  }
  payload.untappedActionablePercent = session.untapped.actionablePercent;
  if (finiteOrUndefined(untappedValuePerAction) !== undefined) {
    payload.untappedValuePerAction = untappedValuePerAction;
  }
  if (finiteOrUndefined(annualEbitda) !== undefined) {
    payload.annualEbitda = annualEbitda;
  }

  const email = session.email.trim();
  if (email) payload.email = email;
  payload.consent = session.consent;

  return payload;
}
